import { create } from 'zustand';
// SERVICE

const initialData = {
  initGroupCharge: null, // 그룹별 객실 요금
  hotel: null, // 호텔 정보 --> 객실 요금, answerRooms setting 때 사용
  inquiry: null, // 객실 문의 상세
  hotelTravelRateGroup: null, // 현재 호텔의 해당 여행사 그룹 정보
  isChangeReq: false, // 여행사 변경요청 유무(true 일 때 변경 요청 내역 노출)
  nextStatusOptions: [], // 변경 가능한 상태 (빈 배열 일 때 모든 항목 disabled 처리--> 호텔에서 처리 해줘야 다음 상태 이용가능)
  roomsType: null, // 호텔 객실 정보
  groupTypes: null, // 그룹 타입
  saveFormData: null, // 뒤로가기를 위하여 form 저장 {}
  scrollState: 0, // 스크롤 상태
};

const MobileInquiryPageStore = create((set, get) => ({
  ...initialData,

  // 단순 데이터 set
  setDtaileStoreState: (key, value) => set({ [key]: value }),

  // 스토어 리셋
  resetInquiryDtaileStore: () => set({ ...initialData }),
}));
export default MobileInquiryPageStore;
